export default __webpack_public_path__ + "static/media/639763463ed2d61a9b24775ffe183f731581603384298.6bc33cf6.webp";